<template>
    <div class="mql-table" :class="tableClass">
        <el-table ref="table"
                  v-loading="loading"
                  @selection-change="handleSelectionChange"
                  @row-click="rowClick"
                  @current-change="currentChange"
                  :data="tableData"
                  :row-style="{background:'transparent'}"
                  :header-cell-style="{background:'#f0f0f0'}"
                  :height="height"
                  :row-key="rowKey"
                  :highlight-current-row="highlightCurrentRow"
                  :show-header="showHeader"
                  style="width: 100%;">
            <slot />
        </el-table>
        <div class="mql-pagination block mr20 mt20 tr">
            <el-pagination :current-page.sync="params.pageNum"
                           :page-sizes="pageSizes"
                           :page-size="params.pageSize"
                           :total="pageParams.total"
                           background
                           layout="total, sizes, prev, pager, next, jumper"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           class="fr" />
        </div>
    </div>
</template>

<script>

export default {
    name: 'MqlTable',
    props: {
        value: {
            type: Array,
            default () {
                return []
            }
        },
        url: {
            type: String,
            required: true
        },
        height: String,
        pageSizes: {
            type: Array,
            default () {
                return [20, 50, 100]
            }
        },
        options: {
            type: Object,
            default () {
                return {}
            }
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        rowHover: {
            type: Boolean,
            default: true
        },
        highlightCurrentRow: Boolean,
        beforeData: Function
    },
    data () {
        return {
            tableData: [],
            params: {
                pageNum: 1,
                pageSize: 20
            },
            pageParams: {
                total: 0
            },
            loading: false
        }
    },
    computed: {
        tableClass () {
            return {
                'un-rowhover': !this.rowHover
            }
        }
    },
    watch: {
        value (val) {
            this.tableData = val
        },
        tableData (val) {
            this.$emit('input', val)
        },
        url (val) {
            if (val) {
                this.getPageList()
            }
        }
    },
    methods: {
        // 获取分页列表（外部调用）
        getPageList (params) {
            if (params) {
                this.params.pageNum = params.pageNum || 1
                this.params.pageSize = params.pageSize || this.params.pageSize
                Object.assign(this.params, params)
            }

            if (!this.url) {
                return
            }
            return new Promise((resolve, reject) => {
                this.loading = true
                this.http.post(this.url, this.params)
                    .then(res => {
                        const data = res.data
                        this.tableData = data.list
                        this.pageParams.total = data.total
                        resolve(this.tableData)
                        this.loading = false
                    }).catch((err) => {
                        reject(err)
                        this.loading = false
                    })
            })
        },
        handleSizeChange (val) {
            this.params.pageSize = val
            this.getPageList()
        },
        handleCurrentChange (val) {
            this.params.pageNum = val
            this.getPageList()
        },
        handleSelectionChange (val) {
            this.$emit('selection-change', val)
        },
        rowClick (row, event, column) {
            this.$emit('row-click', row, event, column)
        },
        rowKey (row) {
            return row.tbKey
        },
        currentChange (currentRow, oldCurrentRow) {
            this.$emit('current-change', currentRow, oldCurrentRow)
        }
    }
}
</script>

<style lang="scss" scoped>
.mql-table {
    display: flex;
    flex-direction: column;
    flex: 1;
    .el-table {
        overflow: auto;
    }
    .mql-pagination {
        justify-content: center;
        padding: 5px;
    }
}
</style>
<style lang="scss">
.mql-table {
    &.un-rowhover{
        .el-table--enable-row-hover .el-table__body tr:hover>td{
            background: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/core/MqlTable/index.vue